import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from './components/AppLayout';
import HomeworkTable from './components/HomeworkTable';
import PageHeader from './components/PageHeader';
import { fetchClassDashboards, fetchDeadline } from './services/whiteboardApi';
import { mergeClassDashboards } from './utils/classDashboard';
import { getStoredClassTokens } from './utils/classTokens';
import { getStoredBoard, selectedGroupTokens } from './utils/subjectGroups';
import { getLocalDateString } from './utils/date';
import { buildDeadlineTable } from './utils/tableData';

function CheckDeadline() {

    const [tableData, setTableData] = useState();
    const [maxCol, setMaxCol] = useState(0);
    const [maxRow, setMaxRow] = useState(0);
    const [deadline, setDeadline] = useState(getLocalDateString);
    const [classTokens] = useState(() => selectedGroupTokens().length
        ? selectedGroupTokens()
        : getStoredClassTokens());
    const [boardId] = useState(getStoredBoard);

    const name = localStorage.getItem('name');

    const fetchData = useCallback(async () => {
        try {
            const data = classTokens.length
                ? mergeClassDashboards((await fetchClassDashboards(classTokens, deadline, boardId)).dashboards)
                : await fetchDeadline(name, deadline);
            const table = buildDeadlineTable(classTokens.length ? data.due_today : data.table);

            setMaxCol(table.maxCol);
            setMaxRow(table.maxRow);
            setTableData(table.tableData);

        } catch (error) {
            console.error('There was a problem with the POST request:', error);
        }
        
    }, [boardId, classTokens, deadline, name]);

    useEffect( () => {
          
        fetchData();

    }, [fetchData]);
    
    return (
        <AppLayout>
            <div className="mx-auto flex w-full max-w-4xl flex-col items-center">
                <PageHeader
                    title={`${deadline}'s Deadline`}
                    action={
                        <input
                            type="date"
                            value={deadline}
                            onChange={(e) => setDeadline(e.target.value)}
                            className="rounded-md border border-gray-300 bg-white p-2 text-base shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    }
                    description="Below is the list of tasks and their corresponding deadlines for today. Please make sure to review and complete your tasks on time."
                />
                <HomeworkTable
                    tableData={tableData}
                    maxRow={maxRow}
                    maxCol={maxCol}
                    transpose
                />
            </div>
        </AppLayout>
    );
  
}

export default CheckDeadline;
